<script lang="ts">
	import StarIcon from 'assets/svg/starWhite.svg?component';
	import NoIcon from 'assets/svg/noCoinIcon.svg?url';
	import TableRow from 'components/Table/TableRow/TableRow.svelte';
	import TableCell from 'components/Table/TableCell/TableCell.svelte';
	import { onMount } from 'svelte';
	import isInViewport from 'utils/isInViewport';
	import { throttle } from 'utils/decorators';
	import activeCurrency from "stores/activeCurrency";

	export let data;
	export let dark: boolean;
	export let list = [];
	export let isModalOpen = false;

	let isInWatchlist: boolean;

	let isInUserViewport = false;
	let isLoaded = false;
	let watchlistModalTableRowRef: HTMLElement;

	function formatPrice(price: string | number, isCompact: boolean) {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: $activeCurrency.currency.toUpperCase(),
			notation: isCompact ? 'compact' : 'standard',
			minimumFractionDigits: 2,
		}).format(Number(price));
	}

	$: list, (isInWatchlist = list?.includes(data?.id));

	function addToList(symbol) {
		if (list?.includes(symbol)) {
			let index = list.indexOf(symbol);
			if (index > -1) {
				list.splice(index, 1);
			}
		} else {
			list = [...list, symbol];
		}
	}

	onMount(() => {
		if (isModalOpen) {
			isInUserViewport = isInViewport(watchlistModalTableRowRef);
		}

		if (data && isInUserViewport) {
			isLoaded = true;
		} else {
			document.addEventListener('scroll', handleScroll);
		}

		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	});

	$: isModalOpen, (isInUserViewport = isInViewport(watchlistModalTableRowRef));

	const handleScroll = throttle(() => {
		if (isModalOpen) {
			isInUserViewport = isInViewport(watchlistModalTableRowRef);
		}
	}, 500);

	$: {
		if (isInUserViewport && !isLoaded && isModalOpen) {
			isLoaded = true;
			document.removeEventListener('scroll', handleScroll);
		}
	}
</script>

<TableRow
	{dark}
	bind:tableRowRef={watchlistModalTableRowRef}
	class="modal-table-row"
	on:click={() => {
		addToList(data.id);
		isInWatchlist = !isInWatchlist;
	}}
>
	{#if isLoaded}
		<TableCell {dark} class="modal-table-row-cell coin-rank">
			<StarIcon
				class={`modal-table-icon ${isInWatchlist ? 'added' : 'not-in-list'}`}
				width={18}
				height={18}
			/>
			<p class="rank">{data.rank ?? '-'}</p>
		</TableCell>
		<TableCell {dark} class="modal-table-row-cell coin-name">
			<img
				src={data.iconUrl ? data.iconUrl : NoIcon}
				alt={`${data.symbol} logo`}
				class="coin-icon"
				loading="lazy"
			/>
			<div class="meta-wrapper">
				<p class="name">{data.name ?? '-'}</p>
				<span class="symbol">{data.symbol}</span>
			</div>
			<p class="name-tablet">{data.name ?? '-'}</p>
		</TableCell>
		<TableCell {dark} class=" modal-table-row-cell coin-symbol"><p>{data.symbol}</p></TableCell>
		<TableCell {dark} class="modal-table-row-cell coin-price">
			{#key $activeCurrency}
				{formatPrice(data.price, false)}
			{/key}
		</TableCell>
	{/if}
</TableRow>

<style lang="scss">
	@import 'modalTableRow';
</style>
